// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./$.wks')('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)require('./$.hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/$.add-to-unscopables.js
 ** module id = 148
 ** module chunks = 0 1 4 5 6 7 8
 **/